/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer
 * @Email : kpozos@ibl.mx
 *
 * @component   : MyApartmentMain
 * @description : This component lists the buildings the logged user belongs to.
 *                It handles pagination and search functionality.
 *                Buildings are rendered as cards instead of table rows.
 *
 * @renders     : - A searchable building card list
 *                - An options menu per card
 *
 * @features    : - Search input
 *                - Modularized actions and list handling
 */

import HeadTittle from '../../components/HeadTittle';
import NotInformation from '../../components/NotInformation';
import SearchSimple from '../../components/SearchSimples/SearchSimple';
import React from "react";
import MyApartmentMainApp from "./Functionality/MyApartmentMainApp";
import MyApartmentCard from "./SubComponents/MyApartmentCard";

const MyApartmentMain = () => {
    const {
        t,
        results,
        setResults,
        searchElement,
        setSearchElement,
        setSearch,
        option,
        searchId,
        rowsPerPage,
        simpleSearch,
        setSimpleSearch,
        setBodyForExport,
        handleSearch,
        handleResetSearch,
        pagination,
        elementRef,
        getActionsButtons
    } = MyApartmentMainApp();


    return (
        <>
            <HeadTittle name={'my_apartments'}/>

            <SearchSimple
                id={searchId}
                setBodyForExport={setBodyForExport}
                setSearchResults={setResults}
                searchResults={results}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                optionTable={option}
                rowsPerPage={rowsPerPage}
                setSearch={setSearch}
                simpleSearch={simpleSearch}
                setSimpleSearch={setSimpleSearch}
                callApi={handleSearch}
                resetApi={handleResetSearch}
            />

            <div className={"mt-4"}>
                {results?.content?.length > 0 ? (
                    <>
                        <div className={'panelTables'} ref={elementRef}>
                            <div className={'row'}>
                                {results?.content?.map((item, index) => (
                                    <MyApartmentCard
                                        key={item?.id}
                                        item={item}
                                        actions={getActionsButtons(item, index)}
                                    />
                                ))}
                            </div>
                        </div>
                        <div className={'col-12'}>{pagination()}</div>
                    </>
                ) : (
                    <NotInformation
                        card={true}
                        text={typeof results?.content === "undefined" ? t('loading') : t('you_are_not_registered_in_any_apartment')}
                    />
                )}
            </div>
        </>
    );
};

export default MyApartmentMain;

